import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';

// Style
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ManageListing.css';

// Component
import ManageListingsComponent from '../../components_new/managelisting/ManageListings';
import Loader from '../../components/Loader';
// Graphql
import ManageListingsQuery from './manageListing.graphql';
import { Whitespace } from '../../components_new/common';
import { connect } from 'react-redux';
import { ManagePublishStatus } from '../../actions/Listing/ManagePublishStatus';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import {
  updateQueryMergeResults,
  updateQueryNewResults,
} from '../../helpers/updateQueryHelpers';

@observer
class ManageListing extends React.Component {
  @observable orderBy = 'recent';
  @observable publishFilter = null;
  static propTypes = {
    ManageListingsQ: PropTypes.shape({
      loading: PropTypes.bool,
      ManageListings: PropTypes.array,
    }),
  };

  static defaultProps = {
    ManageListingsQ: {
      loading: true,
      ManageListings: [],
    },
  };

  removeListing = async id => {
    await this.props.ManagePublishStatus(id, 'unPublish');
    this.loadMore(true);
  };

  updateOrderBy = sort => {
    this.orderBy = sort;
    this.loadMore(true);
  };

  updatePublishFilter = publishFilter => {
    this.publishFilter = publishFilter;
    this.loadMore(true);
  };

  loadMoreScroll = () => {
    this.loadMore();
  };

  loadMore = changedBase => {
    const {
      ManageListingsQ: { loading, ManageListings },
      ManageListingsQ,
    } = this.props;
    let { publishFilter, orderBy } = this;

    if (loading) {
      return;
    }

    let currentPage = ManageListings.currentPage;

    //Build Variables
    //cursor, publishFilter, orderBy
    if (changedBase) {
      currentPage = 0;
    } else {
      currentPage++;
    }

    const variables = { publishFilter, orderBy, currentPage };
    ManageListingsQ.fetchMore({
      variables,
      updateQuery: changedBase
        ? updateQueryNewResults()
        : updateQueryMergeResults('ManageListings.listings'),
    });
  };

  render() {
    const {
      ManageListingsQ: { loading, ManageListings },
    } = this.props;

    return (
      <div className={s.container}>
        {loading && <Loader type={'text'} />}
        {!loading && ManageListings != null && (
          <ManageListingsComponent
            listings={ManageListings.listings}
            removeListing={this.removeListing}
            loadMore={this.loadMoreScroll}
            updatePublishFilter={this.updatePublishFilter}
            updateOrderBy={this.updateOrderBy}
            currentPage={ManageListings.currentPage}
            totalPages={ManageListings.totalPages}
            loading={loading}
          />
        )}
        <Whitespace />
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  connect(
    state => state,
    { ManagePublishStatus },
  ),
  graphql(ManageListingsQuery, {
    name: 'ManageListingsQ',
    options: {
      ssr: false,
      fetchPolicy: 'network-only',
      variables: { orderBy: 'recent' },
    },
  }),
)(ManageListing);



// WEBPACK FOOTER //
// ./src/routes/manageListing/ManageListing.js